import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export function Barcode({ value, height = 38 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    try {
      JsBarcode(ref.current, (value || "000000000000").toString(), {
        format: "CODE128",
        width: 1.5,
        height,
        displayValue: true,
        fontSize: 11,
        margin: 0,
        font: "monospace",
        background: "#ffffff",
        lineColor: "#000000",
      });
    } catch { /* invalid value */ }
  }, [value, height]);
  return <canvas ref={ref} data-testid="label-barcode" style={{ width: "100%", height: "auto", maxWidth: "100%" }} />;
}
